module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "cta-transition",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [(_vm.powerSurgeOverlay) ? _c('div', {
    staticClass: "overlay"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53d9b90b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PowerSurgeOverlay.vue
// module id = 455
// module chunks = 1